import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
      <footer className="footer mt-auto">
          <div className="copyleft bg-white">
              <p>Design And Develop By Shree </p>
              <Link className="text-primary" to="tel:8390135527"> Jinal Joshi - 8390135527</Link> & 
              <Link className="text-primary" to="tel:9537187123"> 9537187123</Link>
          </div>
            <div className="copyright bg-white">
              <p>
                  © <span id="copy-year">2025</span> Copyright cmspvt. All Rights Reserved.
              </p>
            </div>
          </footer>
  );
}
export default Footer;
